import React from 'react';
import { Link, useParams } from 'react-router-dom';
import '../LegalPages.css'; // A shared CSS file for styling
import { useCookieConsent } from '../../../context/CookieConsentContext';

const CookiePolicy = () => {
  const { lang } = useParams();
  const { openSettings } = useCookieConsent();
  return (
    <div className="legal-page-container" dir="rtl">
      <div className="legal-content">
        <h1>מדיניות קובצי Cookie</h1>
        <p>עודכן לאחרונה: 11 באוקטובר, 2025</p>
        <p>מדיניות קובצי Cookie זו מסבירה כיצד אנו משתמשים בקובצי Cookie וטכנולוגיות דומות כדי לזהות אותך בעת ביקורך באתר האינטרנט שלנו. היא מסבירה מהן טכנולוגיות אלו ומדוע אנו משתמשים בהן, וכן את זכויותיך לשלוט בשימוש שלנו בהן.</p>
        <p>SeegSoog.com מופעלת על ידי חברת לוג-אין הבית החכם בע"מ, מספר ח.פ. 514147305, ישראל. מדיניות קובצי ה-Cookie זו חלה על פעילות חברת לוג-אין הבית החכם בע"מ באתר SeegSoog.com.</p>

        <h2>מהם קובצי Cookie?</h2>
        <p>קובץ Cookie הוא קובץ נתונים קטן המוצב במכשירך בעת ביקור באתר אינטרנט. קובצי Cookie נמצאים בשימוש נרחב על ידי בעלי אתרים על מנת לגרום לאתריהם לעבוד, או לעבוד ביעילות רבה יותר, וכן לספק מידע דיווחי.</p>

        <h2>מדוע אנו משתמשים בקובצי Cookie?</h2>
        <p>
          אנו משתמשים בקובצי Cookie של צד ראשון וצד שלישי מכמה סיבות. קובצי Cookie מסוימים נדרשים מסיבות טכניות על מנת שהאתר שלנו יפעל, ואנו מתייחסים אליהם כקובצי Cookie "חיוניים" או "הכרחיים בהחלט". קובצי Cookie אחרים מאפשרים לנו גם לעקוב אחר תחומי
          העניין של המשתמשים שלנו ולמקד אותם כדי לשפר את החוויה בנכסים המקוונים שלנו. צדדים שלישיים מגישים קובצי Cookie דרך האתר שלנו למטרות פרסום, ניתוח ועוד. זה מתואר בפירוט רב יותר להלן.
        </p>

        <h2>באילו סוגי קובצי Cookie אנו משתמשים?</h2>

        <h3>קובצי Cookie חיוניים לאתר</h3>
        <p>
          קובצי Cookie אלה הכרחיים בהחלט כדי לספק לך שירותים הזמינים דרך האתר שלנו ולהשתמש בחלק מהתכונות שלו, כגון גישה לאזורים מאובטחים. מכיוון שקובצי Cookie אלה הכרחיים בהחלט כדי לספק לך את האתר, אינך יכול לסרב להם מבלי להשפיע על אופן פעולת האתר שלנו.
        </p>
        <ul>
          <li>
            <strong>connect.sid:</strong> זהו קובץ ה-Cookie הראשי של הסשן המשמש את היישום שלנו לזיהוי סשן של משתמש לאחר שהוא מתחבר. זהו קובץ Cookie "הכרחי בהחלט".
          </li>
          <li>
            <strong>trusted_device:</strong> קובץ Cookie זה מוגדר כאשר אתה משתמש בהצלחה באפשרות "בטח במכשיר זה" במהלך אימות דו-שלבי. הוא זוכר את המכשיר שלך כדי לעקוף אימות דו-שלבי בכניסות עתידיות.
          </li>
        </ul>

        <h3>קובצי Cookie של ביצועים ופונקציונליות</h3>
        <p>קובצי Cookie אלה משמשים לשיפור הביצועים והפונקציונליות של האתר שלנו אך אינם חיוניים לשימוש בו. עם זאת, ללא קובצי Cookie אלה, פונקציונליות מסוימת עשויה להפוך ללא זמינה.</p>
        <ul>
          <li>
            <strong>i18next / site_language:</strong> קובצי Cookie אלה משמשים לזכירת הגדרת השפה המועדפת עליך כך שהאתר יוצג בשפה שבחרת בביקורים הבאים.
          </li>
        </ul>

        <h3>קובצי Cookie של ניתוח והתאמה אישית</h3>
        <p>קובצי Cookie אלה אוספים מידע המשמש בצורה מצטברת כדי לעזור לנו להבין כיצד נעשה שימוש באתר שלנו או עד כמה יעילים מסעות הפרסום השיווקיים שלנו, או כדי לעזור לנו להתאים אישית את האתר שלנו עבורך.</p>
        <ul>
          <li>
            <strong>Firebase/Google Analytics:</strong> אנו משתמשים ב-Firebase וב-Google Analytics כדי לאסוף מידע על האופן שבו מבקרים משתמשים באתר שלנו. קובצי ה-Cookie אוספים מידע בצורה אנונימית, כולל מספר המבקרים באתר, מהיכן הגיעו המבקרים לאתר והדפים
            שבהם ביקרו. מידע זה משמש לעריכת דוחות ולעזור לנו לשפר את האתר. ניתן למצוא את מדיניות הפרטיות של גוגל כאן:{' '}
            <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">
              https://policies.google.com/privacy
            </a>
          </li>
        </ul>

        <h3>טכנולוגיות מעקב אחרות</h3>
        <p>
          אנו עשויים להשתמש גם בטכנולוגיות אחרות ודומות מעת לעת, כמו משואות רשת (web beacons, לעיתים נקראות "פיקסלים למעקב" או "clear gifs"). אלו הם קבצי גרפיקה זעירים המכילים מזהה ייחודי המאפשר לנו לזהות מתי מישהו ביקר באתר שלנו או פתח דואר אלקטרוני
          ששלחנו לו. זה מאפשר לנו, למשל, לעקוב אחר דפוסי התעבורה של משתמשים מדף אחד בתוך האתר שלנו למשנהו, לספק או לתקשר עם קובצי Cookie, להבין אם הגעת לאתר שלנו מפרסומת מקוונת המוצגת באתר של צד שלישי, לשפר את ביצועי האתר ולמדוד את הצלחת מסעות הפרסום
          בדואר אלקטרוני. במקרים רבים, טכנולוגיות אלו תלויות בקובצי Cookie כדי לתפקד כראוי, ולכן דחיית קובצי Cookie תפגע בתפקודן.
        </p>

        <h2>כיצד אוכל לשלוט בקובצי Cookie?</h2>
        <p>יש לך את הזכות להחליט אם לקבל או לדחות קובצי Cookie שאינם חיוניים. בעת ביקורך הראשון באתר, יוצג בפניך באנר הסכמה לקובצי Cookie שבו תוכל לבצע את בחירתך.</p>
        <p>תוכל לשנות את העדפות קובצי ה-Cookie שלך בכל עת על ידי לחיצה על הכפתור למטה. פעולה זו תפתח מחדש את חלון ההסכמה, ותאפשר לך לשנות את הגדרותיך או לבטל את הסכמתך.</p>
        <p>
          <button className="link-button" onClick={openSettings}>
            נהל הגדרות קובצי Cookie
          </button>
        </p>
        <p>
          בנוסף, באפשרותך להגדיר או לתקן את בקרות דפדפן האינטרנט שלך כדי לקבל או לסרב לקובצי Cookie. אם תבחר לדחות קובצי Cookie דרך הדפדפן שלך, עדיין תוכל להשתמש באתר שלנו, אם כי הגישה שלך לפונקציונליות ולאזורים מסוימים באתר שלנו עשויה להיות מוגבלת.
          מכיוון שהאמצעים שבאמצעותם תוכל לסרב לקובצי Cookie דרך בקרות הדפדפן שלך משתנים מדפדפן לדפדפן, עליך לבקר בתפריט העזרה של הדפדפן שלך לקבלת מידע נוסף.
        </p>

        <h2>שינויים במדיניות קובצי Cookie זו</h2>
        <p>
          אנו עשויים לעדכן מדיניות קובצי Cookie זו מעת לעת על מנת לשקף, למשל, שינויים בקובצי ה-Cookie שאנו משתמשים בהם או מסיבות תפעוליות, משפטיות או רגולטוריות אחרות. אנא בקר מחדש במדיניות קובצי Cookie זו באופן קבוע כדי להישאר מעודכן לגבי השימוש שלנו
          בקובצי Cookie וטכנולוגיות קשורות.
        </p>

        <h2>היכן אוכל לקבל מידע נוסף?</h2>
        <p>
          אם יש לך שאלות כלשהן לגבי השימוש שלנו בקובצי Cookie או טכנולוגיות אחרות, אנא <Link to={`/${lang}/contact-us`}>צור איתנו קשר</Link>.
        </p>
      </div>
    </div>
  );
};

export default CookiePolicy;
